import React from 'react';
import { AlertCircle } from 'lucide-react';

/**
 * SupportTabLayout Component
 * Wrapper component for support tab content with consistent layout and error handling
 */
export const SupportTabLayout = ({ 
  children, 
  title, 
  description,
  action,
  error,
  className = '' 
}) => {
  return (
    <div className={`space-y-6 ${className}`}>
      {/* Header Section */}
      {(title || description || action) && (
        <div className="flex items-start justify-between gap-4">
          <div className="flex-1">
            {title && (
              <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
                {title}
              </h3>
            )}
            {description && (
              <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
                {description}
              </p>
            )}
          </div>
          {action && (
            <div className="flex-shrink-0">
              {action}
            </div>
          )}
        </div>
      )}

      {/* Error Display */}
      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 dark:bg-red-900/10 dark:border-red-800">
          <div className="flex items-start">
            <AlertCircle className="w-5 h-5 text-red-600 mt-0.5 mr-3 flex-shrink-0" />
            <div className="flex-1">
              <h4 className="text-sm font-medium text-red-800 dark:text-red-200">
                Error loading data
              </h4>
              <p className="mt-1 text-sm text-red-700 dark:text-red-300">
                {error.message || 'An unexpected error occurred. Please try again.'}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Content */}
      <div>
        {children}
      </div>
    </div>
  );
};

export default SupportTabLayout;
